package xyz.malefic.guptare.client.styles

object AppFonts {
    const val DISPLAY = "Cinzel"
    const val BODY = "Plus Jakarta Sans"
    val DISPLAY_STACK = arrayOf(DISPLAY, "Times New Roman", "serif")
    val BODY_STACK = arrayOf(BODY, "Segoe UI", "system-ui", "sans-serif")
}
